import { render, staticRenderFns } from "./uploadFiles.vue?vue&type=template&id=42438ad4&scoped=true"
import script from "./uploadFiles.vue?vue&type=script&lang=js"
export * from "./uploadFiles.vue?vue&type=script&lang=js"
import style0 from "./uploadFiles.vue?vue&type=style&index=0&id=42438ad4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42438ad4",
  null
  
)

export default component.exports